import '../sass/school-list.scss';

(() => {
    const $blocks = document.querySelectorAll('.block.school-list');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $list = $block.querySelector('.school-list__list');
        const $cards = $block.querySelectorAll('.school-list__card');
        const $seeAllBtn = $block.querySelector('.school-list__see-all-btn');

        const initCarousels = () => {
            if (!$cards) return;

            $cards.forEach($card => {
                const $cardCarousel = $card.querySelector('.school-list__card-carousel');
                const $cardCarouselNavigationPrev = $card.querySelector('.school-list__card-carousel-navigation-prev');
                const $cardCarouselNavigationNext = $card.querySelector('.school-list__card-carousel-navigation-next');

                new Swiper($cardCarousel, {
                    navigation: {
                        nextEl: $cardCarouselNavigationNext,
                        prevEl: $cardCarouselNavigationPrev,
                    },
                    loop: true,
                });
            })

            if ($seeAllBtn) {
                $seeAllBtn.addEventListener('click', () => {
                    $block.classList.add('school-list--show-all');
                });
            }
        };

        initCarousels();
    });
})();
